(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uju-product-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uju-product-carousel')) {
    customElements.define('uju-product-carousel', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-uju-slide]')];
        this.index = 0;
        this.paused = false;
        this.hovered = false;
        this.focused = false;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.counter = this.querySelector('[data-uju-counter]');
        this.pauseButton = this.querySelector('[data-uju-pause]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.querySelector('[data-uju-prev]')?.addEventListener('click', () => this.show(this.index - 1, true), options);
        this.querySelector('[data-uju-next]')?.addEventListener('click', () => this.show(this.index + 1, true), options);
        this.pauseButton?.addEventListener('click', () => {
          this.paused = !this.paused;
          this.updatePause();
          this.start();
        }, options);
        this.addEventListener('pointerenter', () => { this.hovered = true; }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; }, options);
        this.addEventListener('focusin', () => { this.focused = true; }, options);
        this.addEventListener('focusout', (event) => { this.focused = this.contains(event.relatedTarget); }, options);
        this.motion.addEventListener('change', () => { this.updatePause(); this.start(); }, options);
        this.updatePause();
        this.start();
      }
      updatePause() {
        if (!this.pauseButton) return;
        this.pauseButton.disabled = this.motion.matches;
        const stopped = this.paused || this.motion.matches;
        this.pauseButton.setAttribute('aria-label', stopped ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.pauseButton.firstElementChild.textContent = stopped ? '▶' : 'Ⅱ';
      }
      show(index, manual = false) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        if (this.counter) {
          this.counter.setAttribute('aria-live', manual ? 'polite' : 'off');
          this.counter.textContent = (this.index + 1) + ' / ' + this.slides.length;
        }
        if (manual) this.start();
      }
      start() {
        clearInterval(this.timer);
        if (this.dataset.autoplay !== 'true' || this.paused || this.motion.matches || this.slides.length < 2) return;
        this.timer = setInterval(() => {
          if (!document.hidden && !this.hovered && !this.focused) this.show(this.index + 1);
        }, Math.max(3, Number(this.dataset.speed) || 3) * 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
